import {
  judgTerminal,
  formatDuraton,
  isWeChat,
  isMobileDevice,
} from '@/utils/util'
import { isBuild, typeViteEnv } from '@/utils/env'
import VideoEnPlayer from '../Player'
import VideoLayerDom from '../layer'
import VideoTouchInt from './touchInt'
import VideoDragFixInt from './dragFixInt'
import { timeRangeToArray, hasClass } from '../utils'
import {
  clickReplayBtn,
  clickContainer,
  clickBottomState,
  clickErrorBtn,
  clickErrorBlock,
  clickBottonFullScreen,
  clickLayerStateBlock,
  clickNetworkBlockBtn,
  clickLayerStateBtn,
  clickReplayBlock,
  clickNetworkBlock,
  clickMiniCloseBtn,
  clickMiniLayerBlcok,
  clickMiniLayerBtn
} from './clickInt'

const publicImageUrl = isBuild() ? typeViteEnv('VITE_OSS_BUILD_URL') + 'resource/image' : '/resource/image'

export default class VideoEvents {
  player: VideoEnPlayer
  layerDom: VideoLayerDom
  touchInt: VideoTouchInt
  dragFixInt: VideoDragFixInt
  bottomStateTime: number
  dragFixed: boolean
  playerEnd: boolean
  isDragging: boolean
  clearBottomTime: any
  destroyEvents: any[]

  constructor(player: VideoEnPlayer) {
    this.player = player
    this.bottomStateTime = 3000
    this.dragFixed = false
    this.playerEnd = false
    this.isDragging = false
    this.clearBottomTime = null
    this.destroyEvents = []
    this.proxy = this.proxy.bind(this)

    this.layerDom = new VideoLayerDom(player, this)
    this.touchInt = new VideoTouchInt(player, this)
    this.dragFixInt = new VideoDragFixInt(player, this)

    this.addOtherEvent()
    clickContainer(player, this)
    clickErrorBlock(player, this)
    clickErrorBtn(player, this)
    clickNetworkBlock(player, this)
    clickNetworkBlockBtn(player, this)
    clickLayerStateBlock(player, this)
    clickLayerStateBtn(player, this)
    clickBottomState(player, this)
    clickBottonFullScreen(player, this)
    clickReplayBlock(player, this)
    clickReplayBtn(player, this)
    clickMiniLayerBlcok(player, this)
    clickMiniLayerBtn(player, this)
    clickMiniCloseBtn(player, this)
  }

  clearSetTimeOut() {
    if (this.clearBottomTime) {
      clearTimeout(this.clearBottomTime)
      this.clearBottomTime = null
    }
  }

  initPlayer(init?: boolean) {
    if (!init && !this.player.originPoster) {
      this.player.template.$cover.style.backgroundSize = this.player.options.record.poster ? 'contain' : isMobileDevice() ? `3.52rem 1.6rem` : '132px 60px'
    }

    this.layerDom.toggleCommonLayer(this.player.template.$loading, false)
    this.player.template.$bottomDuration.innerHTML = `${formatDuraton(this.player.player.getDuration())}`

    if (hasClass(this.player.template.$container.parentNode as any, 'init')) {
      this.layerDom.toggleLayerPause(true)
      this.layerDom.toggleCommonLayer(this.player.template.$loading, false)
    } else {
      this.clearSetTimeOut()
      this.layerDom.toggleBottomPlayState(true)
      this.layerDom.toggleCommonLayer(this.player.template.$layerState, false)
    }
  }

  changeVideoHeight() {
    const video = this.player.player ? this.player.player?.tag : null
    const videoWidth = video?.videoWidth || 0
    const videoHeight = video?.videoHeight || 0
    this.player.callBackFun.ready(videoWidth, videoHeight, (height) => {
      this.player.template.$cover.style.height = `${height}px`
      this.player.template.$coverImage.style.height = `${height}px`
    })
  }

  async addOtherEvent() {
    if (isWeChat()) {
      try {
        wx.ready(() => {
          this.player.player?.on('ready', async () => {
            this.changeVideoHeight()
            this.initPlayer()
          })
        })
      } catch (e) {
        this.player.player?.on('ready', async () => {
          this.changeVideoHeight()
          this.initPlayer()
        })
      }
    } else {
      this.player.player?.on('ready', async () => {
        this.changeVideoHeight()
        this.initPlayer()
      })
    }

    this.proxy(this.player.template.$video, 'play', () => {
      this.player.callBackFun.play()

      this.player.template.$bottomDuration.innerHTML = `${formatDuraton(this.player.player.getDuration())}`

      if (this.player.options.record.poster && hasClass(this.player.template.$container?.parentNode as HTMLElement, 'init')) {
        this.layerDom.toggleCommonLayer(this.player.template.$cover, true)
      } else {
        this.layerDom.toggleCommonLayer(this.player.template.$cover, false)
      }
      this.player.callBackFun.pauseOhterDp(this.player.options.record.id)
    })

    this.proxy(this.player.template.$video, 'pause', () => {
      this.player.template.$video.pause()
      this.layerDom.toggleBottomPlayState(false)
    })

    this.proxy(this.player.template.$video, 'playing', () => {
      this.layerDom.toggleCommonLayer(this.player.template.$loading, false)
      this.layerDom.toggleCommonLayer(this.player.template.$cover, false)
    })

    this.proxy(this.player.template.$video, 'waiting', () => {
      this.layerDom.toggleCommonLayer(this.player.template.$loading, true)
    })

    this.proxy(this.player.template.$video, 'progress', () => {
      const buffered = timeRangeToArray(this.player.template.$video.buffered)
      const endBuffer =  buffered.length > 0 ? buffered[buffered.length - 1][1] : 0
      const precent = endBuffer / this.player.player.getDuration() * 100
      this.player.template.$bottomBuffer.style.width = `${precent}%`
      this.player.template.$miniProgressBuffer.style.width = `${precent}%`
    })

    this.proxy(this.player.template.$video, 'loadeddata', () => {
      this.layerDom.toggleCommonLayer(this.player.template.$loading, false)
    })

    this.proxy(this.player.template.$video, 'timeupdate', () => {
      if (this.isDragging) return
      const precent = (this.player.player.getCurrentTime() / this.player.player.getDuration()) * 100
      this.player.template.$bottomCurrent.innerHTML = `${formatDuraton(this.player.player.getCurrentTime())}`
      this.player.template.$bottomLoaded.style.width = `${precent}%`
      this.player.template.$miniProgressLoaded.style.width = `${precent}%`
      if ((this.player.template.$video.currentTime >= this.player.template.$video.duration) && this.player.template.$video.currentTime > 0) {
        if (this.isDragging) return
        if (this.playerEnd) return

        this.playerEnd = true
        this.player.template.$bottomLoaded.style.width = `100%%`
        this.player.template.$miniProgressLoaded.style.width = `100%%`
        if (this.dragFixed) {
          this.player.player.pause()
          this.layerDom.toggleCommonLayer(this.player.template.$miniLayer, true)

          return
        } else {
          this.clearSetTimeOut()
          if (this.player.player.fullscreenService.getIsFullScreen() as any) {
            this.player.player.fullscreenService.cancelFullScreen()
            this.player.template.$bottomFullScreen.setAttribute('src', `${publicImageUrl}/player/fullScreen.svg`)
          }
          this.layerDom.toggleCommonLayer(this.player.template.$replay, true)
          this.layerDom.tooglePlayerBottom(false)
          this.layerDom.toggleBottomPlayState(false)
        }
      } if (this.player.template.$video.currentTime >= 0) {
        this.playerEnd = false
      }
    })

    this.player.player.on('requestFullScreen', () => {
      if (judgTerminal() === 1) {
        this.player.template.$bottomFullScreen.setAttribute('src', `${publicImageUrl}/player/eFullScreen.svg`)
      }
    })

    this.player.player.on('cancelFullScreen', () => {
      this.player.template.$bottomFullScreen.setAttribute('src', `${publicImageUrl}/player/fullScreen.svg`)
    })

    this.player.player.on('error', () => {
      this.player.callBackFun.pointError()
      if (this.dragFixed) {
        this.player.callBackFun.closeFixModal(this.player.options.record.id)
      } else {
        this.layerDom.toggleCommonLayer(this.player.template.$loading, false)
        this.layerDom.toggleCommonLayer(this.player.template.$cover, false)
        this.layerDom.toggleLayerPause(false)
        this.layerDom.toggleCommonLayer(this.player.template.$error, true)
      }
    })
  }

  proxy(target, name, callback, option = {}) {
    if (Array.isArray(name)) {
      return name.map((item) => this.proxy(target, item, callback, option))
    }

    target.addEventListener(name, callback, option)
    const destroy = () => target.removeEventListener(name, callback, option)
    this.destroyEvents.push(destroy)
    return destroy
  }

  remove(destroyEvent) {
    const index = this.destroyEvents.indexOf(destroyEvent)
    if (index > -1) {
      destroyEvent()
      this.destroyEvents.splice(index, 1)
    }
  }

  destroy() {
    for (let index = 0; index < this.destroyEvents.length; index++) {
      this.destroyEvents[index]()
    }
  }
}
